import { render, staticRenderFns } from "./GroupChartWorkcenter.vue?vue&type=template&id=23582c20&"
import script from "./GroupChartWorkcenter.vue?vue&type=script&lang=js&"
export * from "./GroupChartWorkcenter.vue?vue&type=script&lang=js&"
import style0 from "./GroupChartWorkcenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports